import { useEffect, useId, useRef, type ReactNode } from "react";
import { Icon } from "../../app/Icon";

export function AiDialog({ title, open, onClose, children, wide = false, className = "", renderHeader }: { title: string; open: boolean; onClose: () => void; children: ReactNode; wide?: boolean; className?: string; renderHeader?: (titleId: string) => ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      const previous = document.activeElement;
      dialog.showModal();
      return () => {
        dialog.close();
        if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
      };
    } else if (!open && dialog.open) dialog.close();
  }, [open]);
  return <dialog ref={ref} className={`ai-dialog${wide ? " ai-dialog--wide" : ""}${className ? ` ${className}` : ""}`} aria-labelledby={titleId} onCancel={event => { event.preventDefault(); onClose(); }} onClick={event => {
    if (event.target !== event.currentTarget) return;
    const bounds = event.currentTarget.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose();
  }}>
    {renderHeader ? renderHeader(titleId) : <header className="ai-dialog__header"><h2 id={titleId}>{title}</h2><button type="button" className="ai-icon-button" aria-label="Close dialog" onClick={onClose}><Icon name="close" /></button></header>}
    {children}
  </dialog>;
}
